import React from "react";
import { Modal, Row, Col, Form, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { FiCalendar } from "react-icons/fi";
import "react-datepicker/dist/react-datepicker.css";

export default function AddTrainingModal({ show, onHide }) {
  const [startDate, setStartDate] = React.useState(null);
  const [endDate, setEndDate] = React.useState(null);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      className="training-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Add Training</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Row className="g-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Training Type</Form.Label>
                <Form.Select>
                  <option>Select</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>Trainer</Form.Label>
                <Form.Select>
                  <option>Select</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>Employees</Form.Label>
                <Form.Select>
                  <option>Select</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>Training Cost</Form.Label>
                <Form.Control type="text" />
              </Form.Group>
            </Col>

            {/* START DATE */}
            <Col md={6}>
              <Form.Group>
                <Form.Label>Start Date</Form.Label>
                <div className="date-wrapper">
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    placeholderText="dd/mm/yyyy"
                    dateFormat="dd/MM/yyyy"
                    className="form-control"
                  />
                  {/* <FiCalendar className="calendar-icon" /> */}
                </div>
              </Form.Group>
            </Col>

            {/* END DATE */}
            <Col md={6}>
              <Form.Group>
                <Form.Label>End Date</Form.Label>
                <div className="date-wrapper">
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    placeholderText="dd/mm/yyyy"
                    dateFormat="dd/MM/yyyy"
                    className="form-control"
                  />
                  {/* <FiCalendar className="calendar-icon" /> */}
                </div>
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group>
                <Form.Label>Description</Form.Label>
                <Form.Control as="textarea" rows={3} />
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group>
                <Form.Label>Status</Form.Label>
                <Form.Select>
                  <option>Active</option>
                  <option>Inactive</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <div className="footer-btns">
          <Button className="cancel-btn" onClick={onHide}>
            Cancel
          </Button>
          <Button className="submit-btn">Add Training</Button>
        </div>
      </Modal.Footer>

      {/* STYLES */}
      <style>{`
        .training-modal .modal-content {
          border-radius: 10px;
          background: #f9fafb;
          border: none;
        }

        .training-modal .modal-header {
          border-bottom: 1px solid #e5e7eb;
          padding: 18px 20px;
        }

        .training-modal .modal-title {
          font-size: 20px;
          font-weight: 600;
        }

        .training-modal .modal-body {
          padding: 20px;
        }

        .training-modal .form-label {
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 6px;
          color: #374151;
        }

        .training-modal .form-control,
        .training-modal .form-select {
          height: 44px;
          border-radius: 6px;
          border: 1px solid #e5e7eb;
          font-size: 14px;
        }

        .training-modal textarea.form-control {
          height: auto;
          resize: none;
        }

        /* DATE PICKER */
        .date-wrapper {
          position: relative;
        }

        .calendar-icon {
          position: absolute;
          right: 12px;
          top: 50%;
          transform: translateY(-50%);
          color: #6b7280;
          pointer-events: none;
        }

        .training-modal .modal-footer {
          border-top: 1px solid #e5e7eb;
          padding: 15px 20px;
        }

        .footer-btns {
          width: 100%;
          display: flex;
          justify-content: flex-end;
          gap: 10px;
        }

        .cancel-btn {
          background: #e5e7eb;
          border: none;
          color: #111827;
          padding: 8px 18px;
          border-radius: 6px;
        }

        .submit-btn {
          background: #ff6b2c;
          border: none;
          padding: 8px 18px;
          border-radius: 6px;
        }

        .submit-btn:hover {
          background: #e65a1f;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .training-modal .modal-dialog {
            margin: 10px;
          }

          .training-modal .modal-body {
            padding: 15px;
          }

          .footer-btns {
            flex-direction: column;
          }

          .footer-btns button {
            width: 100%;
          }
        }
      `}</style>
    </Modal>
  );
}